<template>
  <div class="jobs-mailing-container">
    <pc-nav-bar/>
    <div class="mailing-content">
      <div class="mailing-tabs">
        <div class="tab-item color_40">网申提醒</div>
      </div>
      <div class="mailing-data-content">
        <div class="list-container">
          <skeleton v-if="pageLoadingShow"></skeleton>
          <template v-else>
            <div class="remind-content">
              <div class="remind-container">
                <div class="remind-item-content">
                  <div class="flex header" @click.prevent="changeSwitch(1)">
                    <span class="color_40 title">收藏网申提醒</span>
                    <el-switch class="application-switch" disabled v-model="favoriteSwitch" active-color="#6FDB5F"
                               inactive-color="#B3B3B3"/>
                  </div>
                  <p class="description">当你收藏的企业，有新的网申开启时，网申更新时，<br>网申还有7天截止时，都会及时收到提醒</p>
                </div>
                <div class="remind-item-content">
                  <div class="flex header" @click.prevent="changeSwitch(2)">
                    <span class="color_40 title">最新网申提醒</span>
                    <el-switch class="favorite-switch" disabled v-model="newSwitch" active-color="#6FDB5F"
                               inactive-color="#B3B3B3"/>
                  </div>
                  <p class="description">不错过任何名企的网申信息，第一时间收到开启的新网申<br>机会，有足够时间挑选和准备。</p>
                </div>
              </div>
              <div class="qr-code">
                <img src="https://files.wondercv.com/net_apply_notice_08_06.png" alt="">
                <p class="color_90">通过 [超级简历WonderCV] 公众号发<br>出网申更新及截止提醒</p>
              </div>
            </div>
          </template>
        </div>
        <div class="jobs-data-container">
          <wx-qr-code></wx-qr-code>
        </div>
      </div>
    </div>
    <campus-code :dialog-state="wxState" :qrUrl='qrUrl' @handleClose="wxState = false" />
    <pc-footer/>
  </div>
</template>

<script>
	import pcNavBar from '../../components/base/navbar'
	import pcFooter from '../../components/base/pcFooter'
	import skeleton from '../../components/base/skeleton'
	import wxQrCode from '../../components/wxQrcode'
  import campusCode from './components/campus-code'
  import {checkJWT} from '../../assets/js/auth'
  import {get_tUser} from '@/assets/js/util';
  import { toLogin } from '@/assets/js/jwt';
  import api from '../../api'

	export default {
		name: 'mailing',
		data () {
			return {
				favoriteSwitch: false,
				newSwitch: false,
				pageLoadingShow: true,
        wxState: false,
        qrUrl:''
			}
    },
    created(){
      let _t = Cookies.get('_t');
      if (!_t) {
        toLogin({login:true});
        return
      }
    },
		mounted () {
			this.initPageData()
		},
		computed: {},
		watch: {},
		components: {
			pcNavBar,
			pcFooter,
			wxQrCode,
			skeleton,
      campusCode
		},
		methods: {
			// 初始化数据
			async initPageData () {
				await this.getApplication()
				this.pageLoadingShow = false
			},
			// 开启或者关闭提醒
			changeSwitch (value) {
				if (value === 1) {
					this.changeApplication({
						type: 'wechat_self_net_application',
						status: this.favoriteSwitch ? 'off' : 'on'
					})
				} else if (value === 2) {
					this.changeApplication({
						type: 'wechat_all_net_application',
						status: this.newSwitch ? 'off' : 'on'
					})
				}
			},
			// 开启或者关闭提醒接口
			async changeApplication (payload) {
        let res = await api.jobs.changeNetApplication(payload)
        //console.log(res)
				if (res.code === 1000) {
					if (payload.type === 'wechat_self_net_application') {
						this.favoriteSwitch = payload.status === 'on'
					} else if (payload.type === 'wechat_all_net_application') {
						this.newSwitch = payload.status === 'on'
					}
					this.$message.success(payload.status === 'on' ? '网申提醒已开启' : '网申提醒已关闭')
				} else if (res.code === 2027) {
            let {c_t} = await get_tUser()

            let query = {
             scene_str: 'bind_'+ c_t,
             account_type: 'cv_account',
             operation_type :'bind',
             expire_seconds: 20
            }
            let wxCode = await api.auth.getRemindCode(query)
            if (wxCode.code === 1000) {
              this.qrUrl = wxCode.data.url
            }
            //console.log(wxCode,this.qrUrl,wxCode.data.qr_url)
				  	this.wxState = true
				}
			},
			// 获取网申提醒
			async getApplication () {
				let res = await api.jobs.getNetApplication()
				if (res.code === 1000) {
					this.favoriteSwitch = res.data.wechat_self_net_application_status
					this.newSwitch = res.data.wechat_all_net_application_status
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
  @import '../../assets/css/public';
  .jobs-mailing-container {
    background-color: #F5F5F7;
    padding-top: 55px;
    .mailing-content {
      width: 1196px;
      padding-top: 16px;
      margin: 0 auto;
      .mailing-tabs {
        display: flex;
        align-items: center;
        width: 100%;
        height: 52px;
        padding-left: 32px;
        background-color: #FFffff;
        margin-bottom: 16px;
        box-sizing: border-box;
      }
      .mailing-data-content {
        display: flex;
        width: 100%;
        .list-container {
          flex: 1;
          margin-right: 16px;
          .remind-content {
            display: flex;
            justify-content: space-between;
            background-color: #FFffff;
            padding: 24px 24px 100px;
            .remind-item-content {
              margin-bottom: 40px;
              .header {
                align-items: center;
                margin-bottom: 24px;
                .title {
                  margin-right: 16px;
                  font-size: 16px;
                }
                .is-disabled {
                  opacity: 1;
                }
                /deep/ .el-switch__core,
                /deep/ .el-switch__label {
                  cursor: pointer !important;
                }
              }
              .description {
                color: #909090;
                line-height: 22px;
              }
            }
            .qr-code {
              display: flex;
              flex-direction: column;
              align-items: center;
              img {
                width: 200px;
                height: 200px;
                margin-bottom: 28px;
              }
              p {
                text-align: center;
                line-height: 20px;
              }
            }
          }
        }
        .jobs-data-container {
          width: 300px;
        }
      }
    }
    .footer-main {
      position: fixed;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
    }
  }
</style>
